const routes = {
  '/': 'Welcome',
  '/dashboard': 'Dashboard',
  '/Metrics':'Metrics',
  '/Assets':'Your Video',
  '/components': 'Components',
  '/Account':'Account',
  '/YourStoryboards/Upload':'Upload',
  '/charts': 'Charts',
  '/storyCreating': 'Storyboard Store',
  '/storyCreating/StoryRequest':'Request a Story',
  '/YourStoryboards':'Your Storyboard',
  '/components/social-buttons': 'Social Buttons',
  '/StoryCreating/details/':'Details',
  '/YourStoryboards/details/':'Details',
  '/components/cards': 'Cards',
  '/components/forms': 'Forms',
  '/components/modals': 'Modals',
  '/components/switches': 'Switches',
  '/components/tables': 'Tables',
  '/components/tabs': 'Tabs',
  '/forms': 'Forms',
  '/forms/basic-forms': 'Basic Forms',
  '/forms/advanced-forms': 'Advanced Forms',
  '/editors': 'Editors',
  '/editors/text-editors': 'Text Editors',
  '/editors/code-editors': 'Code Editors',
  '/icons': 'Icons',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',
  '/plugins': 'Plugins',
  '/plugins/calendar': 'Calendar',
  '/plugins/loading-buttons': 'Loading Buttons',
  '/plugins/notifications': 'Notifications',
  '/plugins/spinners': 'Spinners',
  '/widgets': 'Widgets',
  '/ui-kits': 'UI Kits',
  '/ui-kits/invoicing': 'Invoicing',
  '/ui-kits/invoicing/invoice': 'Invoice',
  '/ui-kits/email/compose': 'Compose',
  '/ui-kits/email/inbox': 'Inbox',
  '/ui-kits/email/message': 'Message',
  '/Upgrade' : 'Upgrade'
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js